// crf测试环境
const GLOBAL_API_ROOT = '/'; // 后端请求地址
const PROJECT_NAME = 'CRF量表管理系统'; // 项目名称
const LOGO = ''; // 项目logo
const ICO = ''; // logo路径,格式为.ico，大小需要256*256的，否则打包会报错
const SYSTEM_NAV = {
    leftNav: [{
        name: 'CRF管理',
        activePath: '/main/manage',
        open: true,
        children: [{
            parent: 'CRF管理',
            name: '访视计划',
            path: '/main/manage/plan-folder',
            activePath: '/main/manage/plan'
        }, {
            parent: 'CRF管理',
            name: 'CRF组合',
            path: '/main/manage/group-folder',
            activePath: '/main/manage/group'
        }, {
            parent: 'CRF管理',
            name: 'CRF模板',
            path: '/main/manage/tem-list',
            activePath: '/main/manage/tem'
        }]
    }, {
        name: 'HIS导出管理',
        path: '/main/export/export-folder',
        activePath: '/main/export'
    }],
}

// 以下是打包桌面端需要用到的
// electron-builder.yml
const APP_ID = 'com.crft.www'; // 应用的唯一id,确认后不要改动了！不然在更新时候，会被认做为两个应用。这个是在apple那里你申请证书的时候，用生成的那个id就可以，类似这种'com.example.app'
const COPYRIGHT = 'crft' // 版权信息

// package.json
const VERSION = '1.0.0'; //版本号
const PACKAGE_NAME = 'crft'; //包名
module.exports = {
    GLOBAL_API_ROOT,
    PROJECT_NAME,
    LOGO,
    SYSTEM_NAV,
    ICO,
    APP_ID,
    COPYRIGHT,
    VERSION,
    PACKAGE_NAME,
};